import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Card} from 'primeng/card';
import {ProjectBaseStepComponent} from '../../../project-base-step/project-base-step.component';
import {TenderPhaseType} from '@frontend/shared-api';
import {ProviderResultsTableComponent} from '../../../../../../shared/components/table/provider-results-table/provider-results-table.component';

@Component({
  selector: 'app-step-8-4-provider-results',
  imports: [TranslocoPipe, Card, ProviderResultsTableComponent],
  templateUrl: './step-6-4-provider-results.component.html',
})
export class Step64ProviderResultsComponent extends ProjectBaseStepComponent {
  protected readonly TenderPhaseType = TenderPhaseType;

  constructor() {
    super();
  }
}
